/**
 * @module app.core
 */

import { autoinject, bindable, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';

@autoinject
export class memberEligibilityPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable({ defaultBindingMode: bindingMode.toView })
    public memberId: string | null = null;

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////

    protected async activate(params: { memberId: string }): Promise<void> {
        if(this.memberId !== params.memberId) { this.memberId = params.memberId; }
    }
    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////

}
